window.popup=function(url){
    $(".mask").height($(document).height());
    $(".mask,.popup").show();
    $(".popup_content").html("<video id=\"video\" width=\"100%\" height=\"100%\" autoplay loop controls=\"controls\"><source src=\"" + url + "\" type=\"video/mp4\" width=\"100%\" height=\"100%\"></video>");
    $(".popup .close").click(function(){
        $(".mask,.popup").hide();
        $(".popup_content").html('');
    })
};